// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"f686106a","386":"11ea5caa","429":"fb6d43e3","660":"51218add"}[chunkId] + ".chunk.css";
};